import { Component, OnInit } from '@angular/core';
import { Gallery, GalleryConfig, ImageItem } from '@ngx-gallery/core';
import { CommonService } from 'src/app/services/common.service';
import { Lightbox as Lightboxs } from '@ngx-gallery/lightbox';
import { DomSanitizer } from '@angular/platform-browser';
declare var Isotope: any;
declare var imagesLoaded: any;
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  activeItem = 0;
  loading = false;
  slides: any = [];
  slideConfig = {
    dots: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
  };
  imageList: any = {
    page: 1,
    offset: 50,
    photos: [],
    totalCount: 0
  }
  imageLoader = false;
  galleryId = 'myLightbox';
  items: any = [];
  videoList: any = {
    page: 1,
    offset: 3,
    data: [],
    totalCount: 0
  }
  videoLoader = false;
  isShowVideo = false;
  videoUrl: any;

  constructor(private _CommonService: CommonService, public lightbox: Lightboxs, public gallery: Gallery, public domSanitizer: DomSanitizer) { }

  ngOnInit(): void {
    this.getPromotionalBanner();
    this.getPhotosGallery();
    this.getActiveVideosList();
  }

  slickInit(e?: any) {
    console.log('slick initialized');
  }

  breakpoint(e?: any) {
  }

  afterChange(e?: any) {
  }

  beforeChange(e?: any) {
    this.activeItem = e?.nextSlide;
  }
  showVideo(data: any) {
    this.videoUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(data.youtube_url);
    this.isShowVideo = true;
  }

  getPromotionalBanner() {
    this.loading = true;
    const sub = this._CommonService.getPromotionalBanner().subscribe((data: any) => {
      if (data.status == true) {
        this.slides = data.data;
      }
      this.loading = false;
    }, (err: any) => {
      this.loading = false;
    });
  }
  getPhotosGallery() {
    this.imageLoader = true;
    const sub = this._CommonService.getPhotosGallery(this.imageList.page, this.imageList.offset).subscribe((data: any) => {
      if (data.status == true) {
        this.imageList.photos = this.imageList.photos.concat(data.photos);
        data.photos.filter((item: any) =>
          this.items.push(new ImageItem({ src: item.photo_url, thumb: item.photo_url, id: item.photo_id }))
        );
        this.imageList.totalCount = data.totalCount;
        this.basicLightboxExample();
      }
      this.imageLoader = false;
    }, (err: any) => {
      this.imageLoader = false;
    });
  }
  getActiveVideosList() {
    this.videoLoader = true;
    const sub = this._CommonService.getActiveVideosList(this.videoList.page, this.videoList.offset).subscribe((data: any) => {
      if (data.status == true) {
        this.videoList.data = data.data
        this.videoList.count = data.count;
      }
      this.videoLoader = false;
    }, (err: any) => {
      this.videoLoader = false;
    });
  }
  photoScroll() {
    if (this.imageList.totalCount > this.imageList.photos.length) {
      this.imageList.page++;
      this.getPhotosGallery();
    }
  }

  imageLoaded() {
    var elem = document.getElementById('photos');
    var iso = new Isotope(elem, {
      itemSelector: '.photos-top',
      layoutMode: 'masonry',
      masonry: {
      }
    });
  }
  basicLightboxExample() {
    const galleryRef = this.gallery.ref(this.galleryId);
    galleryRef.load(this.items);
    const config: GalleryConfig = {
    };
    galleryRef.setConfig(config);
  }
  openLightbox(index: number) {
    this.lightbox.open(index, this.galleryId, {
      panelClass: 'fullscreen'
    });
  }

}
